module.exports = __webpack_public_path__ + "img/react.40a116da.svg";